import { useState } from 'react';
import { FilterPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { MultiDynamicOptionsCreatorFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import DynamicOptionsSelectorV2 from '../../../FormInputs/MultiOptionsSelectorV2/DynamicOptionsSelectorV2';
import { OptionValue } from '../../../FormInputs/MultiOptionsSelectorV2/components/OptionsList/optionsList.types';
import FilterApplyFooter from '../FilterApplyFooter/FilterApplyFooter';
import useDynamicOptionsSelectorsCreatorV2 from './useDynamicOptionsSelectorsCreatorV2';

export interface DynamicOptionsSelectorsCreatorPropsV2 {
  option: MultiDynamicOptionsCreatorFilter;
  onClickApply: () => void;
  list?: FilterPreferenceRecognizedLists;
}

const DynamicOptionsSelectorsCreatorV2 = ({
  option,
  list,
  onClickApply,
}: DynamicOptionsSelectorsCreatorPropsV2) => {
  const { filterLogic, handleClickApply, onChangeState, state } =
    useDynamicOptionsSelectorsCreatorV2({ option, list, onClickApply });
  const [isDirty, setIsDirty] = useState(false);

  return (
    <>
      <DynamicOptionsSelectorV2
        fullWidth
        fillHeight
        options={filterLogic.allOptions}
        isLoadingOptions={filterLogic.isLoading}
        loadMoreOptions={filterLogic.handleLoadMoreOptions}
        value={state}
        onChange={(value) => {
          setIsDirty(true);
          return onChangeState(value as OptionValue[]);
        }}
        hideSearchField={false}
        canReorder={!isDirty}
      />
      <FilterApplyFooter disabled={!isDirty} onClickApply={handleClickApply} />
    </>
  );
};

export default DynamicOptionsSelectorsCreatorV2;
